<template>
  <drag-modal :visible="$store.state.dislog.Fiveteen" @cancel="cancel" :title="(step < 181 ? '添加进度-' : '') + litetit"
    :class="{ editbox: Edit }" :width="'860px'">
    <div class="navbox" v-if="Edit">
      <Nscroll @getIndex="see" @delCopy="copydel" :openEdit="openEdit" v-if="step < 181"></Nscroll>
      <div class="intopbtn" v-if="!isAllDis">
        <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
          <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
        </a-popconfirm> -->
        <a-button icon="edit" v-if="
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) &&
          $store.getters.publicPower
        " style="margin-left: 10px" @click="editbtn(false)" :class="{ rd: audit.length > 0 }">{{ openEdit ? '修改' :
          '取消修改' }}</a-button>
        <a-popconfirm title="确认删除结清记录吗?" ok-text="确定" cancel-text="取消" @confirm="editbtn(true)" v-if="
          step == 181 &&
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del) &&
          $store.getters.publicPower
        ">
          <a-button icon="delete" type="danger" style="margin-left: 12px">删除</a-button>
        </a-popconfirm>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="twobox">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 12 }" :wrapper-col="{ span: 24 }">
          <a-form-model-item :label="timeLabel" prop="time" :rules="{
            required: true,
            message: '请选择时间',
            trigger: 'change',
          }" v-if="step >= 160" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
            <a-date-picker v-model="form.time" placeholder="请选择" format="YYYY-MM-DD" type="date"
              valueFormat="YYYY-MM-DD" :disabled="openEdit" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item label="结清金额" prop="clear_fee" :rules="{
            required: true,
            message: '请输入结清金额',
            trigger: 'blur',
          }" v-if="step == 181" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
            <a-input v-model="form.clear_fee" placeholder="请输入" type="number" :disabled="openEdit" />
          </a-form-model-item>
          <a-form-model-item label="案号" prop="no" :rules="{ required: false, message: '请输入案号', trigger: 'blur' }"
            :label-col="{ span: 3 }" v-if="step == 170" :wrapper-col="{ span: 10 }">
            <a-input v-model="form.no" placeholder="请输入案号" :disabled="openEdit" />
          </a-form-model-item>
          <a-form-model-item label="承办法官" prop="judge" :rules="{
            required: false,
            message: '请输入承办法官',
            trigger: 'blur',
          }" :label-col="{ span: 3 }" v-if="step < 180" :wrapper-col="{ span: 10 }">
            <a-input v-model="form.judge" placeholder="请输入承办法官" :disabled="openEdit" />
          </a-form-model-item>
          <a-form-model-item label="联系方式" prop="judge_tel" :rules="{
            required: false,
            message: '请输入联系方式',
            trigger: 'blur',
          }" :label-col="{ span: 3 }" v-if="step < 180" :wrapper-col="{ span: 10 }">
            <a-input v-model="form.judge_tel" placeholder="请输入联系方式" :disabled="openEdit" />
          </a-form-model-item>
          <a-form-model-item label="结案阶段" prop="state" :rules="{
            required: true,
            message: '请选择结案方式',
            trigger: 'blur',
          }" :label-col="{ span: 3 }" v-if="step == 180" :wrapper-col="{ span: 10 }">
            <a-select v-model="form.state" placeholder="请选择结案阶段" :disabled="openEdit">
              <a-select-option :value="1">开庭前调解</a-select-option>
              <a-select-option :value="2">开庭后判决前</a-select-option>
              <a-select-option :value="3">判决后执行前</a-select-option>
              <a-select-option :value="4">执行后拒执前</a-select-option>
              <a-select-option :value="5">拒执后</a-select-option>
              <a-select-option :value="6">特殊结案</a-select-option>
              <a-select-option :value="7">执行驳回</a-select-option>
              <a-select-option :value="8">驳回诉清</a-select-option>
            </a-select>
          </a-form-model-item>
          <div>
            <div class="licter" v-if="!openEdit">
              <label>补充材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for="(i, index) in form.supp" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    补充材料：电子
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 6 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    补充材料：微信
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请输入补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    补充材料：现场
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入补充提交人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请输入补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    补充材料：邮寄
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入收件人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" style="white-space: nowrap" size="small"
                          v-else>
                          <a-radio-button :value="null" style="
                              width: 64px;
                              text-align: center;
                              font-size: 12px;
                            ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                              width: 65px;
                              font-size: 12px;
                              text-align: center;
                            ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                              width: 65px;
                              font-size: 12px;
                              text-align: center;
                            ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="邮寄地址" :prop="'supp.' + index + '.addr'" :rules="{
                        required: true,
                        message: '请输入邮寄地址',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.addr" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>

            <div class="licter" v-if="!openEdit">
              <label>接收材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1, 1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2, 1)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3, 1)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4, 1)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for="(i, index) in form.accept_file" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    接收材料：电子
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    接收材料：微信
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请输入接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    接收材料：现场
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请输入接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    接收材料：邮寄
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" size="small" style="white-space: nowrap"
                          v-else>
                          <a-radio-button :value="null" style="
                              width: 64px;
                              text-align: center;
                              font-size: 12px;
                            ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                              width: 65px;
                              font-size: 12px;
                              text-align: center;
                            ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                              width: 65px;
                              font-size: 12px;
                              text-align: center;
                            ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="邮寄地址" :prop="'accept_file.' + index + '.addr'" :label-col="{ span: 12 }"
                        :wrapper-col="{ span: 24 }" :rules="{
                          required: true,
                          message: '请输入邮寄地址',
                          trigger: 'blur',
                        }">
                        <a-input v-model="i.addr" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'"
                        :label-col="{ span: 12 }" :wrapper-col="{ span: 24 }">
                        <a-input v-model="i.comment" :disabled="openEdit" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item :label="txtLabel" prop="content"
            :rules="{ required: true, message: '请输入', trigger: 'change' }"
            v-if="!loading && [150, 160, 170].indexOf(step) < 0" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <Textarea :content="form.content" @contentVal="
              (element) => {
                form.content = element
              }
            " :edit="openEdit" :keyArr="['time', 'user']">
            </Textarea>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" style="margin-top: 20px" prop="files" :rules="{
            required: false,
            message: '请上传附件',
            trigger: 'change',
          }">
            <Upload :fList="form.files" @upFileAfter="
              (element) => {
                form.files = element
              }
            " :edit="openEdit" v-if="!loading" :Wid="'102px'" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if="!openEdit" style="text-align: center">
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button type="primary" style="width: 148px"> 提交 </a-button>
            </a-popconfirm>
            <a-button style="
                margin-left: 20px;
                width: 148px;
                background: #b2c9e1;
                color: #fff;
              " @click="cancel">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>
</template>
<script>
import Nscroll from '@/components/nscroll'
import Upload from '@/components/uploads'
import { mapGetters, mapActions } from 'vuex'
import { zblastAdd, zblastEdit, zblastLists, zblastDel } from '@/server/speed'
import Textarea from '@/components/textarea'
import { formatTime } from '../../../assets/js/formData'
const formItem = {
  judge: null,
  judge_tel: null,
  supp: [],
  accept_file: [],
  content: [{ content: '' }],
  files: [],
}
const formKey = {
  150: {
    //执行中
    key: 'zxz',
    txtLabel: '执行进度',
  },
  160: {
    //执行中
    key: 'zb',
    txtLabel: '终本原因',
    time: '终本时间',
  },
  170: {
    //执行中
    key: 'hfzx',
    txtLabel: '恢复原因',
    time: '恢复时间',
  },
  180: {
    //执行中
    key: 'ja',
    txtLabel: '备注',
    time: '结案时间',
  },
  181: {
    key: 'jq',
    txtLabel: '结清原因',
    time: '结清时间',
  },
}
export default {
  name: 'Fiveteen',
  computed: {
    ...mapGetters(['litetit', 'Edit']),
    rKey() {
      //150-180  key
      return formKey[this.step].key
    },
    txtLabel() {
      //150-180  textarea
      return formKey[this.step].txtLabel
    },
    timeLabel() {
      return formKey[this.step].time
    },
    rformItem() {
      //150-180
      let mrform = ['judge', 'judge_tel', 'content']
      if (this.step == 150) {
        mrform.push('supp', 'accept_file')
      }
      if (this.step == 160) {
        mrform.push('time', 'supp', 'accept_file')
      }
      if (this.step == 170) {
        mrform.push('time', 'no', 'supp', 'accept_file')
      }
      if (this.step >= 180) {
        mrform = ['time', 'content', 'supp', 'accept_file']
        if (this.step == 180) {
          mrform.push('state')
        }
        if (this.step > 180) {
          mrform.push('clear_fee')
        }
      }

      return mrform
    },
  },
  components: {
    Textarea,
    Upload,
    Nscroll,
  },
  data() {
    return {
      audit: [],
      isAllDis: this.$route.query.t,
      form: JSON.parse(JSON.stringify(formItem)),
      step: this.$store.state.StepLite * 1,
      rules: {},
      loading: true,
      openEdit: false,
    }
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        let nkey = this.rKey
        zblastLists(
          { cause_id: this.$store.state.cause.id, step: this.step },
          this.step
        ).then((e) => {
          if (this.step <= 180) {
            this.$store.dispatch("settime", e.list[0][nkey].update_time)
          }
          e.list.map((ele) => {
            if (ele[nkey]) {
              ele[nkey].content =
                JSON.stringify(ele[nkey].content) == '{}'
                  ? [{ content: '' }]
                  : ele[nkey].content
            } else {
              ele[nkey] = JSON.parse(JSON.stringify(formItem))
            }
            if (this.step == 181) {
              ele[nkey].clear_fee = ele[nkey].clear_fee / 100
            }
            if (this.step >= 150) {
              ele[nkey].supp = Object.keys(ele[nkey].supp).map((key) => ele[nkey].supp[key])
              ele[nkey].accept_file = Object.keys(ele[nkey].accept_file).map((key) => ele[nkey].accept_file[key])
              ele[nkey].supp.map((element) => {
                for (let val in element) {
                  if (!element[val]) {
                    delete element[val]
                  }
                }
                if (element.type * 1 == 4) {
                  element.gout =
                    !element.receive_time && !element.return_time
                      ? null
                      : element.receive_time
                        ? 'a'
                        : 'b'
                }
              })
              ele[nkey].accept_file.map((element) => {
                for (let val in element) {
                  if (!element[val]) {
                    delete element[val]
                  }
                }
                if (element.type * 1 == 4) {
                  element.gout =
                    !element.receive_time && !element.return_time
                      ? null
                      : element.receive_time
                        ? 'a'
                        : 'b'
                }
              })
            }
          })
          this.Infokey({ key: 'infoList', value: e.list })
          this.see(0)
          if (this.step == 180) {
            this.audit = e.list[0].audit
          }
          if (this.step == 181) {
            this.audit = e.list[0].jq.audit
          }
        })
        this.openEdit = true
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove',
    }),
    async copydel(index) {
      //删除进度
      await this.Newdel({
        index: index,
        formKey: this.rformItem,
        valkey: this.rKey,
      }).then((e) => {
        this.form = JSON.parse(JSON.stringify(e))
        this.loading = false
      })
    },
    confirm() {
      this.$refs.forms.validate((valid) => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          let curIndex = this.$store.state.DisForm.curIndex
          for (let val in form) {
            if (!form[val]) {
              delete form[val]
            }
          }
          if(form.no){
              form.no = form.no.replace(/\s/g, '');
          }
          if(form.content){
            form.content=form.content.filter(ele=>{return ele.content})
          }
          let isEditCopyAdd =
            this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0
              ? true
              : false //当前是否是在修改下的新增
          if (form.files && form.files.length > 0) {
            form.files = form.files.map((ele) => {
              return ele.upload_id || ele.id || ele
            })
          }
          if (this.step >= 150) {
            form.supp.map((ele) => {
              if (ele.type == 4) {
                if (ele.gout == 'a') {
                  delete ele.return_time
                } else if (ele.gout == 'b') {
                  delete ele.receive_time
                } else {
                  delete ele.return_time
                  delete ele.receive_time
                }
                delete ele.gout
              }
            })
            form.accept_file.map((ele) => {
              if (ele.type == 4) {
                if (ele.gout == 'a') {
                  delete ele.return_time
                } else if (ele.gout == 'b') {
                  delete ele.receive_time
                } else {
                  delete ele.return_time
                  delete ele.receive_time
                }
                delete ele.gout
              }
            })
          } else {
            delete form.supp
            delete form.accept_file
          }

          if (this.Edit && !isEditCopyAdd) {
            //修改
            if (this.step < 181) {
              let step_id = this.$store.state.DisForm.infoList[curIndex][this.rKey].id
              form.id = step_id
            } else {
              form.id = this.$store.getters.debInfo.clear.id
              form.clear_fee = form.clear_fee * 100
            }
            zblastEdit(form, this.step).then((e) => {
              this.$message.success({ content: '修改成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          } else {
            if (this.step < 181) {
              form.cause_id = this.$store.state.cause.id
            } else {
              form.clear_fee = form.clear_fee * 100
              form.debtor_id = this.$route.params.id
            }
            zblastAdd(form, this.step).then((e) => {
              this.$message.success({
                content: this.step == 181 ? '已申请结清' : '新增成功',
                key: 'updatable',
              })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    plusAdd(type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    editbtn(bool) {
      if (this.audit.length > 0) {
        this.$message.error('正在审核中')
        return false
      }
      if (bool) {
        zblastDel({ id: this.$store.getters.debInfo.clear.id }).then((e) => {
          this.$message.success({ content: '已提交审核', key: 'updatable' })
          this.$parent.$parent.init(this.$store.state.cause.id)
          //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
          this.reset()
        })
      } else {
        this.openEdit = !this.openEdit
      }
    },
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    copyNew() {
      //新增复制进度
      this.loading = true
      let copyItem = {
        cause_id: null,
        id: null,
        title: this.litetit,
      }
      copyItem[this.rKey] = formItem
      this.addNew(copyItem).then((index) => {
        this.form = JSON.parse(JSON.stringify(formItem))
        this.loading = false
      })
    },
    async see(index) {
      //查看切换 审批
      this.loading = true
      this.seeInfo({
        index: index,
        formKey: this.rformItem,
        valkey: this.rKey,
      }).then((e) => {
        if (this.step == 181) {
          e.files = this.$store.getters.debInfo.clear.files
        }
        this.form = JSON.parse(JSON.stringify(e))
        this.loading = false
      })
    },
    reset() {
      this.reMove().then((e) => {
        this.$refs.forms.resetFields()
        this.$store.dispatch('openkey', { key: 'Fiveteen', by: false })
        if (this.step == 181) {
          setTimeout((e) => {
            window.history.go(0)
          }, 500)
        }
      })
    },
    cancel() {
      this.reMove().then((e) => {
        this.$refs.forms.resetFields()
        this.$store.dispatch('openkey', { key: 'Fiveteen', by: false })
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  },
}
</script>

<style lang="less" scoped>
.ilikecon {
  max-height: 400px;
  overflow: auto;
}

.intopbtn .rd {
  opacity: 0.8;
  border-color: #ff9800;
  color: #ff9800;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 16px;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-form-item-label {
    text-align: left;
  }
}

.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 14px;
    text-align: right;
    width: 92px;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}
</style>
